var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({},'div',_vm.options.attrs,false),_vm.options.on),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }